import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=4bd6f2ac&scoped=true&lang=pug&"
import script from "./sub-header.vue?vue&type=script&lang=js&"
export * from "./sub-header.vue?vue&type=script&lang=js&"
import style0 from "./sub-header.vue?vue&type=style&index=0&id=4bd6f2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6f2ac",
  null
  
)

export default component.exports